import axios from "axios";
import config from "./config";
import Cookies from "js-cookie";

let uri;
const access_token = config.key.token;
const refresh_token = config.key.refreshToken;

console.log("Environment:", process.env.REACT_APP_ENVIRONMENT);
console.log("API URI:", process.env.REACT_APP_URI);

if (process.env.REACT_APP_ENVIRONMENT === "development") {
  uri = "http://localhost:5005/";
} else if (process.env.REACT_APP_ENVIRONMENT === "staging") {
  uri = process.env.REACT_APP_URI;
} else if (process.env.REACT_APP_ENVIRONMENT === "production") {
  uri = process.env.REACT_APP_URI;
}

const Axios = axios.create({ baseURL: uri + "v1", withCredentials: true });

// Request interceptor to attach access token to all requests
Axios.interceptors.request.use(
  (config) => {
    // Get the access token from cookies
    const token = Cookies.get(access_token);

    // If token exists, add it to the Authorization header
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    // Set default Content-Type if not already set
    if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => {
    // Handle request errors
    return Promise.reject(error);
  },
);

// Response interceptor to handle token expiration
Axios.interceptors.response.use(
  (response) => {
    // If the response is successful, simply return the response
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // Check if the error is due to an expired token (status 401)
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      try {
        // Send a request to refresh the token
        const refreshToken = Cookies.get(refresh_token); // Get the refresh token
        const refreshResponse = await axios.post(
          uri + "v1/auth/refresh",
          {
            token: refreshToken,
          },
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${Cookies.get(access_token)}`,
            },
          },
        );

        if (refreshResponse.status === 200) {
          const newAccessToken = refreshResponse?.data?.data?.accessToken;

          // Store the new access token
          Cookies.set(access_token, newAccessToken);

          // Update the Authorization header with the new access token and retry the original request
          originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;

          // Retry the original request
          return Axios(originalRequest);
        }
      } catch (refreshError) {
        // Handle refresh token failure (e.g., redirect to login)
        console.error("Refresh token failed", refreshError);
        // Clear tokens and redirect to login
        Cookies.remove(access_token);
        Cookies.remove(refresh_token);
        window.location.href = "/sign-in";
        return Promise.reject(refreshError);
      }
    }

    // Navigate to signin
    if (
      error.response &&
      error.response.status === 401 &&
      error.response?.data?.message === "You're not authenticated"
    ) {
      if (
        window.location.pathname !== "/logout" &&
        window.location.pathname !== "/login"
      ) {
        // Clear tokens before redirect
        Cookies.remove(access_token);
        Cookies.remove(refresh_token);
        window.location.href = "/sign-in";
      }
    }

    // If the error is not due to token expiration or retry fails, reject the error
    return Promise.reject(error);
  },
);

export const BaseURL = uri;
export default Axios;
